import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Client-side redirect for a renamed route. Carries the query string (and any
 * matched path params, via `build`) across the move so old bookmarks, the dev
 * last-route replay, and in-app links that still point at the pre-split path
 * keep working. Used for the /mastery → /progress and
 * /mastery/session/:id → /history/session/:id renames; the cross-link sweep
 * repoints the in-app producers in a later lane, but these bridges stay for
 * external bookmarks.
 */
const LegacyRouteRedirect: React.FC<{
  build: (params: Readonly<Record<string, string | undefined>>) => string;
}> = ({ build }) => {
  const params = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: build(params), search: location.search }}
      replace
    />
  );
};

export default LegacyRouteRedirect;
